import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormControlProps } from '@mui/material';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { Field } from 'formik';

import { useFormField } from 'src/components/userAdmin/UserBulkEditDialog/components/BulkEditDialog';

import { styles } from './index.styles';

export interface BulkEditRadioGroupProps extends FormControlProps {
  name: string;
}

/**
 * Helper component that renders a radio group.
 */
const BulkEditRadioGroup: FC<BulkEditRadioGroupProps> = ({
  name,
  sx = [],
  ...props
}) => {
  const { t } = useTranslation(['admin', 'common']);
  const field = useFormField(name);

  if (!field) return null;

  const fieldLabelId = `${field.name}-label`;

  return (
    <FormControl
      className="BulkEditRadioGroup-root"
      sx={{ ...styles.bulkEditRadioGroup, ...(Array.isArray(sx) ? sx : [sx]) }}
      {...props}
    >
      <FormLabel sx={styles.bulkEditRadioLabel} id={fieldLabelId}>
        {t(field.label)}
      </FormLabel>
      <Field
        aria-labelledby={fieldLabelId}
        as={RadioGroup}
        data-test-id={`user-admin-bulk-edit-${field.name}`}
        name={field.name}
        sx={{ flexDirection: 'row' }}
        {...props}
      >
        {field.choices.map(({ label, value }) => (
          <FormControlLabel
            control={<Radio />}
            key={label}
            label={t(label)}
            value={value}
            sx={styles.bulkEditRadioControlLabel}
          />
        ))}
      </Field>
    </FormControl>
  );
};
export default BulkEditRadioGroup;
